export default __webpack_public_path__ + "static/media/chart-reset-icon.d64877a7.svg";